import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import ContactSection from '../HomePage/ContactSection'
import NewsLetter from '../HomePage/NewsLetter'
import Footer from '../HomePage/Footer'
import PrivacyPolicy from './PrivacyPolicy'

function PrivacyPolicyIndex() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <PrivacyPolicy />
      <ContactSection />
      <NewsLetter />
      <Footer />
    </div>
  )
}

export default PrivacyPolicyIndex
